import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Authentication } from '@hsi/ui-core'; 
import { UtilityService } from "@core/services/utility.service";
import { Router } from '@angular/router'; 

@Injectable({
    providedIn: 'root'
})
export class AuthenticatedUserGuard  {
    constructor(
        private authenticationService: Authentication.Core.AuthenticationService,
        private utilityService: UtilityService,
        private router:Router){ }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean{
        if(!this.authenticationService.authenticatedUser)
        {
            this.utilityService.say("Authentication Required.");
            this.router.navigate(['/login']);
            return false;
        } 
        return true;
    }
}